import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=198114b0&scoped=true"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198114b0",
  null
  
)

export default component.exports